<template>
  <v-card flat class="minHeight">
    <v-toolbar
      absolute
      id="searchBar"
      :class="{ 'elevation-1 largeToolbar': showSearchBar }"
      dense
    >
      <template v-if="!showSearchBar">
        <v-divider vertical></v-divider>
        <v-btn flat color="primary" icon @click="autocompleteInputGetFocus">
          <v-icon>search</v-icon>
        </v-btn>

        <v-divider vertical></v-divider>

        <v-btn-toggle v-model="parkingListFormatView" class="forced">
          <v-btn
            flat
            v-if="!showAsList"
            icon
            light
            color="primary"
            value="list"
            @click="changeTitle"
          >
            <v-icon>list</v-icon>
          </v-btn>
          <v-btn
            flat
            v-else
            light
            icon
            color="primary"
            value="map"
            @click="changeTitle"
          >
            <v-icon>map</v-icon>
          </v-btn>
        </v-btn-toggle>

        <v-divider vertical v-show="isLogged"></v-divider>

        <v-btn
          flat
          color="primary"
          icon
          v-show="isLogged"
          @click="showFavoriteParkings"
        >
          <v-icon v-if="isShowingFavorites">favorite</v-icon>
          <v-icon v-else>favorite_border</v-icon>
        </v-btn>

        <v-divider vertical></v-divider>

        <v-btn-toggle
          v-model="view"
          id="navChooseBookingType"
          class="px-2"
          mandatory
          multiple
        >
          <v-btn
            flat
            class="capitalize"
            value="reservation"
            @click="filterParkingList('reservation', 'plan')"
          >
            {{ $t('home.navbar.reservation') }}
          </v-btn>
          <v-btn
            flat
            class="capitalize"
            value="plan"
            @click="filterParkingList('plan', 'reservation')"
          >
            {{ $t('home.navbar.plan') }}
          </v-btn>
        </v-btn-toggle>
        <v-divider vertical></v-divider>
      </template>

      <template v-if="showGoogleMapSearchBar">
        <gmap-autocomplete
          @place_changed="setPlace"
          :options="map.autoCompleteOptions"
          :selectFirstOnEnter="map.selectFirstOnEnter"
          enable-geolocation
          :placeholder="$t('home.map.searchbar.placeholder')"
          @blur="autocompleteInputLostFocus"
          ref="autocompleteInput"
          v-if="showSearchBar"
        >
        </gmap-autocomplete>
      </template>
      <template v-if="showTextFieldSearch">
        <v-text-field
          @blur="autocompleteInputLostFocus"
          ref="searchTextBar"
          :placeholder="$t('home.list.searchbar.placeholder')"
          clearable
          class="px-3"
          v-model="searchText"
        >
          <!-- @click:clear="autocompleteInputLostFocus" -->
        </v-text-field>
      </template>
    </v-toolbar>

    <gmap-map
      :center="map.center"
      :zoom="map.zoom"
      id="map"
      :options="map.options"
      v-if="parkingListFormatView === 'map'"
    >
      <gmap-info-window
        :options="map.infoOptions"
        :position="map.infoWindowPos"
        :opened="map.infoWinOpen"
        @closeclick="map.infoWinOpen = false"
      >
      </gmap-info-window>
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :title="m.title"
        :icon="m.icon"
        @click="handleMarkerClick(m)"
      ></gmap-marker>
    </gmap-map>

    <!-- v-else-if="$vuetify.breakpoint.xs" -->
    <v-container v-else grid-list-xs style="padding-top: 60px">
      <v-layout row wrap>
        <template v-for="parking in parkingList">
          <v-flex
            class="xs12 sm3"
            :key="parking.id"
            v-if="isParkingActive(parking)"
          >
            <v-card
              class="ma-2"
              height="95%"
              hover
              @click="gotToDetail(parking)"
            >
              <v-img
          height="200"
          :aspect-ratio="16 / 9"
          :src="getParkingImage(parking)"
          cover
          class="text-white"
        >
        </v-img>
        <v-btn v-if="parking.hasElectricSpots" style="position: absolute; top: 5px; right: 5px;"
          color="white"
          icon
          small>
          <v-icon color="primary">bolt</v-icon>
        </v-btn>
              <v-card-title class="pb-0 font-weight-medium">{{
                parking.name
              }}</v-card-title>
              <v-card-text>{{ parking.address }}</v-card-text>
            </v-card>
          </v-flex>
        </template>
      </v-layout>
    </v-container>
    <parking-list-modal
      @on-close="onCloseModal"
      v-if="isShowingParkingListModal"
      :parkings-array="parkingsSameLocation"
      :handle-go-to-detail="gotToDetail"
    >
    </parking-list-modal>
  </v-card>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps';
import parkingService from '@/services/parkingService';
import utilService from '@/services/utilService';
import _ from 'lodash';
import store from '@/store';
import manageErrorService from '@/services/manageErrorService';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';

import ParkingListModal from '@/components/commons/ParkingListModal.vue';

const sortByDistance = require('sort-by-distance');

export default {
  name: 'Home',
  components: {
    [ParkingListModal.name]: ParkingListModal,
  },
  computed: {
    selectedCity() {
      return store.state.citySelected;
    },
    isLogged() {
      return store.state.isLogged;
    },
    google: function() {
      // if (VueGoogleMaps === null) {
      //   return null;
      // }
      if (typeof VueGoogleMaps.gmapApi() === 'undefined') {
        return null;
      }
      return VueGoogleMaps.gmapApi();
    },
    showAsList() {
      return this.parkingListFormatView !== 'map';
    },
    hideOnlyResevations() {
      // return this.view === 'reservation';
      return !this.view.includes('reservation');
    },
    hideOnlyPlans() {
      // return this.view === 'plan';
      return !this.view.includes('plan');
    },
    showGoogleMapSearchBar() {
      return this.showSearchBar && !this.showAsList;
    },
    showTextFieldSearch() {
      return this.showSearchBar && this.showAsList;
    },
    twitterHashtag() {
      return store.state.countrySelected.twitterHashtag;
    }
  },
  watch: {
    google: function() {
      if (this.google == null) {
        return;
      }
      this.initializeGoogle();
    },
    searchText: function(newValue) {
      this.drawParkingsInMap();
    }
  },
  data() {
    return {
      showSearchBar: false,
      parkingListFormatView: null,
      view: ['reservation', 'plan'],
      store: store,
      markers: [],
      map: {
        selectFirstOnEnter: true,
        options: {
          scrollwheel: false,
          clickableIcons: true,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false
        },
        center: {},
        currentMidx: null,
        infoWindowPos: null,
        infoWinOpen: false,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        markerSelected: {
          prescriptorName: '',
          prescriptorAddress: '',
          prescriptorObservation: ''
        },
        autoCompleteOptions: {
          componentRestrictions: {
            country: _.toLower(store.state.countrySelected.code)
          }
        }
      },
      debounceSearch: {},
      parkingList: [],
      isShowingFavorites: false,
      searchText: null,
      parkingsSameLocation: [],
      isShowingParkingListModal: false,
    };
  },

  mounted() {
    this.parkingListFormatView = 'map';
    let hasRestoreData = false;

    if (store.state.restoreHomeData) {
      if (store.state.parkingsNetwork.length === 0) {
        this.loadParkings();
      }
      store.commit('SET_RESTORE_HOME_DATA', { data: false });
      let storeData = store.state.homeData;
      let clone = _.cloneDeep(storeData);

      this.isShowingFavorites = clone.isShowingFavorites;
      this.searchText = clone.searchText;
      this.view = clone.view;
      this.drawParkingsInMap();
      hasRestoreData = true;
    } else {
      store.commit('SAVE_HOME_DATA', { data: {} });
    }

    if (store.state.isShowingParkingAsList) {
      this.parkingListFormatView = 'list';
    }

    this.changeTitle();

    if (hasRestoreData) {
      store.commit('SAVE_HOME_DATA', { data: {} });
      return;
    }

    this.loadParkings();
  },

  created() {
    this.map.center = {
      lat: Number(this.selectedCity.lat),
      lng: Number(this.selectedCity.lon)
    };
    this.map.zoom = Number(this.selectedCity.zoom);

    this.debounceSearch = _.debounce(this.drawParkingsInMap, 500);

    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },

  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },

  methods: {
    onCloseModal() {
      this.isShowingParkingListModal = false;
    },

    showParkingListModal() {
      this.isShowingParkingListModal = true;
    },

    changeLanguage(params) {},

    initializeGoogle() {
      let circle = new google.maps.Circle({
        center: this.center,
        radius: 10000
      });

      this.map.autoCompleteOptions.bounds = circle.getBounds();
    },

    async loadParkings() {
      let params = {};
      let result = await parkingService.listParkings(params);
      if (result.error) {
        manageErrorService.handle(result.data);
        this.ticketLoading = false;
        return;
      }

      store.commit('UPDATE_PARKINGS_NETWORK', {
        parkings: _.cloneDeep(result.data)
      });

      this.drawParkingsInMap();
    },

    showFavoriteParkings() {
      this.isShowingFavorites = !this.isShowingFavorites;
      this.drawParkingsInMap();
    },

    filterOnlyReservations(parkings) {
      if (this.hideOnlyPlans) {
        return _.filter(parkings, itParking => {
          return !itParking.onlySubscription;
        });
      }

      return parkings;
    },

    filterFavoriteParkings(parkings) {
      if (!this.isShowingFavorites) {
        return parkings;
      }

      return _.filter(parkings, itParking => {
        return itParking.isFavorite;
      });
    },

    filterBySearchText(parkings) {
      if (_.isEmpty(this.searchText)) {
        return parkings;
      }
      return _.filter(_.cloneDeep(parkings), itParking => {
        let inTitle = itParking.name
          .toLowerCase()
          .indexOf(this.searchText.toLowerCase());
        let inAddress = itParking.address
          .toLowerCase()
          .indexOf(this.searchText.toLowerCase());

        return inTitle >= 0 || inAddress >= 0;
      });
    },

    drawParkingsInMap() {
      let parkings = this.filterOnlyReservations(
        _.cloneDeep(store.state.parkingsNetwork)
      );
      parkings = this.filterByPlans(parkings);
      parkings = this.filterFavoriteParkings(parkings);
      parkings = this.filterBySearchText(parkings);

      this.parkingList = parkings;
      this.markers = [];
      _.each(this.parkingList, itParking => {
        let parkingIcon;
        if (parkingService.isCommingSoonParking(itParking)) {
          parkingIcon = '/image/markers/COMMING.png';
        } else {
          if (parkingService.availableParkingMarkers().includes(itParking.marker)) {
            parkingIcon = '/image/markers/' + itParking.marker + '.png';
          } else {
            parkingIcon = '/image/markers/WSP.png';
          }
        }
        itParking.hasElectricSpots = itParking.marker && itParking.marker.includes('_E');

        this.markers.push({
          position: { lat: itParking.lat, lng: itParking.lon },
          icon: {
              url: parkingIcon,
              scaledSize: parkingIcon.includes('_E') ? {width: 51, height: 57} : {width: 31, height: 50},
          },
          title: itParking.name,
          parkingId: itParking.id,
          address: itParking.address,
          alias: itParking.alias,
          image: itParking.image,
          hasElectricSpots: itParking.hasElectricSpots
        });
      });

      const opts = {
        yName: 'lat',
        xName: 'lon'
      };
      this.parkingList = sortByDistance(
        store.state.citySelected,
        this.parkingList,
        opts
      );
    },

    handleMarkerClick(marker) {
      // find same locations parkings
      this.parkingsSameLocation = this.markers.filter((it) => {
        if (it.position.lat === marker.position.lat && it.position.lng === marker.position.lng) return true;
        else return false
      });
      if (this.parkingsSameLocation.length === 1) {
        this.gotToDetail(marker)
      } else {
        // show parkings list modal
        this.showParkingListModal();
      }
    },

    gotToDetail(marker) {
      store.commit('SAVE_HOME_DATA', {
        data: {
          isShowingFavorites: this.isShowingFavorites,
          searchText: this.searchText,
          view: this.view,
          showAsList: this.showAsList
        }
      });
      if (marker.id === -999) {
        _.remove(this.markers, it => it.id === -999);
        return;
      }
      if (this.isLogged) {
        this.$router.push({
          path: this.$i18n.t('urlParkingDetail', { alias: marker.alias })
        });
      } else {
        this.$router.push({
          path: this.$i18n.t('urlParkingDetailPage', { alias: marker.alias })
        });
      }
    },

    setPlace(place) {
      _.remove(this.markers, it => it.id === -999);

      this.markers.unshift({
        position: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        },
        id: -999,
        icon: {
              url: '/image/markers/SEARCH.png',
              scaledSize: {width: 31, height: 50},
          }
      });

      this.map.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      };

      this.map.zoom = Number(this.selectedCity.zoom) + 4;

      this.showSearchBar = false;
    },

    changeTitle() {
      this.$nextTick(() => {
        if (this.parkingListFormatView === 'map') {
          if (this.searchText !== null) {
            this.drawParkingsInMap();
            this.searchText = null;
          }

          store.commit('CHANGE_TITLE_SECTION', { text: 'home.map.title' });
        } else {
          store.commit('CHANGE_TITLE_SECTION', { text: 'home.list.title' });
        }
        store.commit('CHANGE_SHOWING_PARKING_AS_LIST', {
          showAsList: this.showAsList
        });
      });
    },

    filterParkingList(active, other) {
      if (this.view.includes(active) && this.view.length === 1) {
        this.view = [other];
      }
      this.$nextTick(() => {
        this.drawParkingsInMap();
      });
    },

    autocompleteInputGetFocus() {
      this.showSearchBar = true;
      this.$nextTick(() => {
        if (typeof this.$refs.autocompleteInput !== 'undefined') {
          this.$refs.autocompleteInput.$refs.input.focus();
        }

        if (typeof this.$refs.searchTextBar !== 'undefined') {
          this.$refs.searchTextBar.focus();
        }
      });
    },
    autocompleteInputLostFocus() {
      if (this.showAsList) {
        this.showSearchBar = false;
      } else if (this.$refs.autocompleteInput.$el.value === '') {
        this.showSearchBar = false;
      }
    },

    getParkingImage(parking) {
      let imageSize = utilService.getParkingImageSize(
        this.$vuetify.breakpoint.name,
        false
      );
      return `${parking.image}?${imageSize}`;
    },

    isParkingActive(parking) {
      return parkingService.isActivedParking(parking);
    },

    filterByPlans(parkings) {
      if (this.hideOnlyResevations) {
        return _.filter(parkings, itParking => itParking.hasPlans);
      }

      return parkings;
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  height: calc(100vh - 50px);
  width: auto;
}
.xs #map,
.sm #map {
  height: calc(100vh - 117px);
}
#bookingType {
  max-width: 180px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  background: none rgb(255, 255, 255);
  bottom: 84px;
  right: 66px;
  left: auto;
}
#bookingType button {
  width: 100px;
}

#searchBar {
  top: 10px;
  left: 10px;
  // width: 320px;
  width: auto;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  background: none rgb(255, 255, 255);
}

#searchBar input {
  width: 100% !important;
  padding-left: 15px;
  padding-right: 15px;
  outline: none;
  display: block;
  position: absolute;
  height: 100%;
  background: white;
}
.poi-info-window .view-link {
  display: none;
}
.pac-container {
  width: 60% !important;
  left: 10px !important;
}
.pac-logo:after {
  background: none !important;
}
#navChooseBookingType .v-btn--active {
  font-weight: 600;
  color: #5ea4c8 !important;
}
#navChooseBookingType .v-btn--active:before {
  background-color: transparent;
}
</style>

<style lang="scss">
#searchBar .v-toolbar__content {
  padding: 0 !important;
}

#parkingList .v-list__tile {
  border-bottom: 1px solid #5ea4c8 !important;
}

.largeToolbar {
  width: calc(100% - 20px) !important;
}
.forced.v-btn-toggle .v-btn {
  opacity: 1 !important;
}
</style>
ype .v-btn--active {
  font-weight: 600;
  color: #5ea4c8 !important;
}
#navChooseBookingType .v-btn--active:before {
  background-color: transparent;
}
</style>

<style lang="scss">
#searchBar .v-toolbar__content {
  padding: 0 !important;
}

#parkingList .v-list__tile {
  border-bottom: 1px solid #5ea4c8 !important;
}

.largeToolbar {
  width: calc(100% - 20px) !important;
}
.forced.v-btn-toggle .v-btn {
  opacity: 1 !important;
}
</style>
0, 0, 0, 0.3) 0px 1px 4px -1px;
  background: none rgb(255, 255, 255);
}

#searchBar input {
  width: 100% !important;
  padding-left: 15px;
  padding-right: 15px;
  outline: none;
  display: block;
  position: absolute;
  height: 100%;
  background: white;
}
.poi-info-window .view-link {
  display: none;
}
.pac-container {
  width: 60% !important;
  left: 10px !important;
}
.pac-logo:after {
  background: none !important;
}
#navChooseBookingType .v-btn--active {
  font-weight: 600;
  color: #5ea4c8 !important;
}
#navChooseBookingType .v-btn--active:before {
  background-color: transparent;
}
</style>

<style lang="scss">
#searchBar .v-toolbar__content {
  padding: 0 !important;
}

#parkingList .v-list__tile {
  border-bottom: 1px solid #5ea4c8 !important;
}

.largeToolbar {
  width: calc(100% - 20px) !important;
}
.forced.v-btn-toggle .v-btn {
  opacity: 1 !important;
}

button.capitalize.v-btn.v-btn--active.v-btn--flat.theme--light {
  border-right-color: white !important;
}

</style>
